import React, {FC, useEffect, useState} from "react";
import {Button, Dropdown, Modal, Skeleton, Table, notification} from "antd";
import {deleteRoleWithCms, getRoleList} from "../actions";
import DotsIcon from "../../manage-reestr-item/dots.svg";
import AddRole from "./add-role";


const RolesManagement: FC<any> = (props: any) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<any[]>([]);
    const [isAction, setIsAction] = useState<number>();
    const [isAddRoleOpen, setIsAddRoleOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState<number>();

    const items = [
        {
            label: 'Редактировать роль',
            key: '1',
        },
        {
            label: 'Удалить роль',
            key: '2',
        },
    ];

    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
            width: '100px'
        },
        {
            title: 'Наименование',
            dataIndex: 'name',
            key: 'name',
            render: name => name && name['ru'],
        },
        {
            title: 'Действия',
            key: 'actions',
            width: '100px',
            render: (_, data) => (
                <Dropdown menu={{ items, onClick: ({ key }) => onClick(key, data) }} trigger={['click']}>
                    <Button className="p-0" shape="round" icon={<DotsIcon />} loading={isAction === data.id} />
                </Dropdown>
            ),
        }
    ];

    const onClick = (key: string, data: any) => {
        switch (key) {
            case '1': edit(data); break;
            case '2': remove(data.id); break;
        }
    };

    const edit = (data: any) => {
        setSelectedRole(data);
        setIsAddRoleOpen(true);
    };

    const remove = (id: number) => {
        setIsAction(id);

        deleteRoleWithCms(props.roleService, id)
            .then(
                () => {
                    notification['success']({
                        message: 'Роль успешно удалена',
                    });
                    loadData();
                }
            )
            .finally(() => setIsAction(null));
    };

    const handleCancel = () => {
        props.handleCancel();
        setSelectedRole(undefined);
    };

    const openAddRoleModal = () => {
        setIsAddRoleOpen(true);
    };

    const closeAddRoleModal = (isUpdate = false) => {
        setIsAddRoleOpen(false);
        setSelectedRole(undefined);

        if (isUpdate) {
            loadData();
        }
    };

    const loadData = () => {
        getRoleList().then(
            value => {
                const d = [...value.data.filter(x => x.id !== 1).sort((a, b) => {
                    if (a.name.ru < b.name.ru) {
                        return -1;
                    }
                    if (a.name.ru > b.name.ru) {
                        return 1;
                    }
                    return 0;
                })];

                setData(d);
            }
        ).finally(
            () => setIsLoading(false)
        )
    };

    useEffect(() => {
        if (props.isModalOpen === true) {
            loadData();
        }
    }, [props.isModalOpen]);

    return (
        <>
            <Modal title="Управление ролями и правами"
                   open={props.isModalOpen}
                   onCancel={handleCancel}
                   width='85%'
                   maskClosable={false}
                   footer={null}
            >
                {isLoading ? (
                    <Skeleton />
                ) : (
                    <div className="user-roles">
                        <div className="my-3 d-flex justify-content-end">
                            <Button type="primary" className="admin" onClick={openAddRoleModal}>
                                Добавить роль
                            </Button>
                        </div>

                        <Table columns={columns}
                               dataSource={data}
                               className="my-3"
                               loading={isLoading}
                        />
                    </div>
                )}
            </Modal>

            <AddRole {...props}
                     isModalOpen={isAddRoleOpen}
                     handleCancel={closeAddRoleModal}
                     handleOk={() => closeAddRoleModal(true)}
                     selectedRole={selectedRole}
            />
        </>
    );
};

export default RolesManagement;
